import { useState } from 'react';
import { logError } from '@dx-ui/framework-logger';
import { generateError } from '@dx-ui/utilities-generate-error';
import type { LoginFormResponse, SourceID } from '../login-form/login-form.types';

export type FormData = {
  username: string;
  password: string;
};

type LoginRequestBody = FormData & {
  partner?: boolean;
};

type UseLoginReturn = {
  login: (
    formData: FormData,
    sourceId: SourceID,
    partner?: boolean
  ) => Promise<LoginFormResponse | null>;
  loading: boolean;
};

const useLogin = (): UseLoginReturn => {
  const [loading, setLoading] = useState(false);

  const login = async (
    formData: FormData,
    sourceId: SourceID,
    partner?: boolean
  ): Promise<LoginFormResponse | null> => {
    setLoading(true);

    try {
      const postOptions: RequestInit = {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Accept: 'application/json; charset=utf-8',
        },
      };

      const requestBody: LoginRequestBody = partner ? { ...formData, partner: true } : formData;

      const response = await fetch(`/en/auth2/api/guest/login/${sourceId}/`, {
        ...postOptions,
        body: JSON.stringify(requestBody),
      });

      const result: LoginFormResponse = await response.json();
      return result;
    } catch (error) {
      const safeError = generateError(error);
      logError('GUEST_LOGIN', safeError);
      return Promise.reject(safeError);
    } finally {
      setLoading(false);
    }
  };

  return { login, loading };
};

export default useLogin;
